import React from 'react'
import PropTypes from 'prop-types'

const PressHeaderCell = props => {
  const q = new URLSearchParams(location.search)
  /**
   * Helper function to determine if a specific type has been selected.
   * It grabs the information from the URL params.
   * @param {string} value - The filter value
   */
  const hasSelectedType = value => {
    if (!value) return false
    if (q.get('filter') !== 'type') return false
    return q.get('value') === value
  }

  return (
    <th
      id={props.id}
      className={[
        'press-header-cell type-body mod-ui mod-sort',
        props.onAction ? 'mod-has-action' : 'mod-no-action',
        props.className
      ].join(' ')}
      data-id="type"
      onClick={e => {
        if (!props.onAction || !props.id) return
        props.onAction(e, props.id)
      }}
    >
      {props.children}

      {props.id && props.onAction && (
        <button
          className={`post-table-filter ${hasSelectedType(props.id) ? 'is-active' : ''}`}
          onClick={e => props.onAction(e)}
        ></button>
      )}
    </th>
  )
}

PressHeaderCell.defaultProps = {
  className: ''
}

PressHeaderCell.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onAction: PropTypes.func
}
export default PressHeaderCell
